import { Component, ojs, app, v, state } from "modular-openscriptjs";
import {
    formatThousand,
    formatDateForHumans,
    either,
    isMobile,
    consoleErrorOnLocal,
    inform,
} from "../../helpers";
import { tool } from "../../fotastart";
import { api, STRINGS } from "../../declarations";
import { routes } from "../../backendRoutes";

const h = app("h");

export default class ViewOrder extends Component {
    orderState = state(null);

    render(orderState, ...args) {
        const order = orderState.value;
        if (!order) return h.empty();
        this.orderState = orderState;

        return h.div(
            h.div(
                {
                    class: "d-flex justify-content-between align-items-center mb-4 border-bottom pb-2 sticky-top bg-white",
                },
                h.div(
                    h.h5(
                        { class: "fw-bold mb-0 text-dark" },
                        `Order #${order.order_code || order.id}`,
                    ),
                    h.small(
                        { class: "text-muted" },
                        formatDateForHumans(order.created_at),
                    ),
                ),
                h.button(
                    {
                        class: "btn-close",
                    },
                    either(
                        isMobile(),
                        { data_bs_dismiss: "offcanvas" },
                        { data_bs_dismiss: "modal" },
                    ),
                ),
            ),

            // Layout Container
            h.div(
                { class: "d-grid gap-4" },
                // Items List
                h.div(
                    {},
                    h.h6(
                        {
                            class: "fw-bold mb-3 text-secondary text-uppercase fs-xsm",
                            style: "letter-spacing: 0.5px;",
                        },
                        "Order Items",
                    ),
                    h.div(
                        { class: "d-grid gap-3" },
                        ...order.items.map((item) =>
                            this.renderItemRow(item, order),
                        ),
                    ),
                ),
            ),
            ...args,
        );
    }

    renderItemRow(item, order) {
        const allowedStatuses = [];
        const currentStatus = item.status || "queued";

        if (currentStatus === "queued") {
            allowedStatuses.push({ value: "preparing", label: "Preparing" });
            allowedStatuses.push({ value: "ready", label: "Ready" });
        } else if (currentStatus === "preparing") {
            allowedStatuses.push({ value: "ready", label: "Ready" });
        }

        let statusText = currentStatus.toUpperCase();

        let statusBadgeColor = "secondary";
        if (currentStatus === "preparing") statusBadgeColor = "warning";
        else if (currentStatus === "ready") statusBadgeColor = "success";
        else if (currentStatus === "picked") statusBadgeColor = "info";

        const statusBadge = h.div(
            {
                class: "d-flex justify-content-between align-items-center mb-1 w-100",
            },
            h.small({ class: "text-muted fw-bold" }, `ITEM STATUS:`),
            h.span(
                {
                    class: `badge bg-${statusBadgeColor} rounded-pill text-uppercase px-2.5 py-1 fs-xsm`,
                },
                statusText,
            ),
        );

        const actionButtons =
            allowedStatuses.length > 0
                ? h.div(
                      { class: "d-flex gap-2 pt-2 w-100" },
                      ...allowedStatuses.map((statusObj) => {
                          const isActive = item.status === statusObj.value;
                          let btnClass = "";
                          let iconClass = "";

                          if (statusObj.value === "preparing") {
                              btnClass = isActive
                                  ? "btn btn-warning text-dark border-warning fw-bold fs-6 py-2"
                                  : "btn btn-outline-warning text-warning-emphasis border-warning-subtle fw-semibold fs-6 py-2";
                              iconClass = "bi bi-hourglass-split me-2";
                          } else if (statusObj.value === "ready") {
                              btnClass = isActive
                                  ? "btn btn-success text-white border-success fw-bold fs-6 py-2"
                                  : "btn btn-outline-success border-success-subtle fw-semibold fs-6 py-2";
                              iconClass = "bi bi-check-circle-fill me-2";
                          }

                          return h.button(
                              {
                                  class: `${btnClass} flex-grow-1 shadow-sm rounded-3 d-flex align-items-center justify-content-center`,
                                  onclick: this.method("updateItemStatus", [
                                      item,
                                      statusObj.value,
                                  ]),
                              },
                              h.i({ class: iconClass }),
                              statusObj.label,
                          );
                      }),
                  )
                : h.empty();

        let itemView = h.empty();
        const cardAttributes = {
            class: "p-3 border rounded-4 bg-white shadow-sm mb-3",
        };

        if (
            item.buyable_type === "App\\Models\\Product" ||
            item.buyable_type === "Product"
        ) {
            itemView = h.ProductView(
                item,
                order,
                statusBadge,
                actionButtons,
                cardAttributes,
            );
        } else if (
            item.buyable_type === "App\\Models\\OrderProduct" ||
            item.buyable_type === "OrderProduct"
        ) {
            itemView = h.OrderProductView(
                item,
                order,
                statusBadge,
                actionButtons,
                cardAttributes,
            );
        } else if (
            item.buyable_type === "App\\Models\\Service" ||
            item.buyable_type === "Service"
        ) {
            itemView = h.ServiceView(
                item,
                order,
                statusBadge,
                actionButtons,
                cardAttributes,
            );
        } else {
            itemView = h.ProductView(
                item,
                order,
                statusBadge,
                actionButtons,
                cardAttributes,
            );
        }

        return itemView;
    }

    async updateItemStatus(item, newStatus) {
        if (item.status === newStatus) return;

        const oldStatus = item.status;
        item.status = newStatus;

        try {
            const res = await api.put(`order-items/${item.id}/status`, {
                status: newStatus,
            });

            if (res) {
                inform(`Item marked as ${newStatus}`, STRINGS.SUCCESS);
            }
        } catch (e) {
            item.status = oldStatus;
            inform("Failed to update item status", STRINGS.ERROR);
        } finally {
            let res = await api.get(
                routes.viewOrder(
                    this.orderState.value?.pivot.company_id,
                    this.orderState.value?.id,
                ),
            );

            if (res) {
                this.orderState.value = res.data.order;
            }
        }
    }
}

ojs(ViewOrder);
